import { render, staticRenderFns } from "./BannersForm.vue?vue&type=template&id=22972d68&"
import script from "./BannersForm.vue?vue&type=script&lang=js&"
export * from "./BannersForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports